import React, { memo } from "react";
import styled from "styled-components";
import { Modal } from "antd";
import icon_cancel_black from "assets/icon_cancel_black.svg";
import { CloseOutlined } from "@ant-design/icons";

// images

const ModalContent = memo(
  ({
    className,
    modalIsOpen,
    onCancel,
    onConfirm,
    isShowBtnCancel,
    title,
    content,
    error,
    titleCancel,
    titleConfirm,
    loading,
    icon,
    isShowCancel,
    titleByCash,
    isShowbuttonCancel,
    conCancelModal,
  }) => {
    return (
      <div className={className}>
        <Modal
          className={`custom-modal-rating ${className}`}
          open={modalIsOpen}
          footer={null}
          centered
          closable={false}
          zIndex={200001}
          maskClosable={false}
        >
          {isShowbuttonCancel && (
            <CloseOutlined
              className={"btnCloseModal"}
              onClick={conCancelModal || onCancel}
            />
          )}
          <div>
            {isShowCancel && (
              <div
                onClick={() => {
                  onCancel();
                }}
                className=" absolute right-0 top-0 mr-2 mt-2"
              >
                <img
                  src={icon_cancel_black}
                  className="img-menu-logo w-16 mt-5"
                  alt="warning"
                />
              </div>
            )}
            {icon && (
              <div className="flex justify-center items-center mt-4">
                <img
                  src={icon}
                  className="img-menu-logo w-16 mt-5"
                  alt="warning"
                />
              </div>
            )}
            <div className="text-center font-700 fs-16 ml-4 mr-4 pt-5">
              {title}
            </div>
            {titleByCash && (
              <div className="text-center font-700 fs-16 ml-4 mr-4">
                {titleByCash}
              </div>
            )}
            {content && (
              <div className="text-center ml-4 mr-4 text-content pt-3">
                {content}
              </div>
            )}
            {error && (
              <div className="text-center ml-4 mr-4 text-content pt-3">
                {error}
              </div>
            )}
            <div
              className={
                isShowBtnCancel
                  ? "flex justify-between mt-5 items-center mb-2 mx-2"
                  : "flex justify-center mt-5 items-center mb-2 mx-2"
              }
            >
              {isShowBtnCancel ? (
                <div
                  onClick={onCancel}
                  className="btn_skip w-1/2 font-500 py-3 mx-2 fs-14 mb-5"
                >
                  {titleCancel || ""}
                </div>
              ) : null}
              {onConfirm && (
                <div
                  onClick={onConfirm}
                  className="btn_ok w-1/2 font-500 py-3 mx-2 fs-14 mb-5"
                >
                  {titleConfirm || ""}
                </div>
              )}
            </div>
          </div>
        </Modal>
      </div>
    );
  }
);

export default styled(ModalContent)`
  .btnCloseModal {
    color: #000;
    background-color: #FFF;
    top: -10px;
    right: -10px;
    position: absolute;
    font-size: 16px;
    border-radius: 100px;
    padding: 6px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.5);
    z-index: 2;
  }
  
  &.modal-icon-custom {
    .img-menu-logo {
      width: 116px;
    }
    .btnCloseModal {
      top: 12px;
      right: 12px;
      border-radius: 0;
      box-shadow: none;
      font-size: 22px;
    }
  }
  .text-content {
    line-height: 20px;
    font-weight: 400;
    font-size: 14px;
    color: #808080;
    font-family: "Manrope", sans-serif;
  }
`;
